import Model from 'ln/model/Model';
import { ChapterElement, Chapter } from '../chapter';

export class Video extends Model implements ChapterElement{

    public readonly chapter:Chapter;
    
    public getViewName(): string {
        return 'Video';
    }
}